import {Injectable} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ApiConnectService} from '../services/api-connect.service';
import {ReportDatepickerPlatform} from './report-datepicker.platform';
import {
  GroupReportStorageContext,
  PersonalReportStorageContext
} from './report-datepicker.types';

@Injectable()
export class ReportDatepickerUiGateway {
  constructor(
    private activeModal: NgbActiveModal,
    private apiConnectService: ApiConnectService,
    private platform: ReportDatepickerPlatform
  ) {
  }

  close(result?: Object | string): void {
    this.activeModal.close(result);
  }

  planfixUrl(taskId: number): string {
    return this.apiConnectService.getPlanfixTaskUrl(taskId);
  }

  openPlanfix(taskId: number): void {
    this.platform.openExternal(this.planfixUrl(taskId));
  }

  schedule(action: () => void, delay: number): void {
    this.platform.schedule(action, delay);
  }

  storeDepartment(department: Object): void {
    this.platform.storeDepartment(department);
  }

  storeVector(vector: Object): void {
    this.platform.storeVector(vector);
  }

  storePersonalReport(context: PersonalReportStorageContext): void {
    this.platform.storePersonalReport(context);
  }

  storeGroupReport(context: GroupReportStorageContext): void {
    this.platform.storeGroupReport(context);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-ui.gateway.ts